import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel2Slash = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16.7097 6.20966L15.5 5L3 5L3 19L4 19", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M19.5 3.5L2 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M23.9141 12L15.9141 20H7.24316L9.24316 18H15.085L21.085 11.999L18.1641 9.07812L19.5781 7.66406L23.9141 12Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconLabel2Slash.js.map